
<template>
  <div>
    <v-card :outlined="$vuetify.theme.isDark">
      <v-card-title>Mover apenas os elementos do departamento "{{ department.name }}"?</v-card-title>
      <v-card-subtitle class="pb-0">Escolha quais elementos do departamento você deseja mover para um novo destino</v-card-subtitle>
      <card-loading-transparent
        v-if="loading"
        :loadingText="loading_text"
      ></card-loading-transparent>
      <v-card-text
        v-if="!loading && associations"
        class="pb-0"
      >
        <v-form ref="moveForm">
          <div 
            v-if="!associations || !Object.keys(associations).length"
            class="pt-3 mb-0"  
          >
            <v-alert
              type="info"
            >
              Não há elementos associados a este departamento
            </v-alert>
          </div>
          <div
            v-if="Object.keys(associations).length"
            v-for="(association, idx) in associations"
          >
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  class=""
                  v-model="association.move"
                  :label="associations_map[association.name].text"
                  color="secondary"
                ></v-checkbox>
              </v-col>
              <v-col
                v-if="association.move"
                class="d-flex align-center"
              >
                <v-btn
                  class="mr-2"
                  color="secondary"
                  :outlined="association.type != 'all' || (association.type == 'all' && !association.dept_id)"
                  small
                  rounded
                  @click="setMoveType(association, 'all')"
                >
                  Mover tudo
                </v-btn>
                <v-btn
                  class="ml-2"
                  color="secondary"
                  :outlined="association.type != 'individual' || (association.type == 'individual' && !association.dept_id)"
                  small
                  rounded
                  @click="setMoveType(association, 'individual')"
                >
                  Selecionar individualmente
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
            color="error"
            text
            @click="$emit('back')"
          >
            Voltar
          </v-btn>
          <v-btn
            v-if="associations"
            color="success"
            text
            @click="submitMove"
          >
            Mover
          </v-btn>
      </v-card-actions>
    </v-card>

    <select-department-dialog
      v-if="select_dept_dialog"
      :department="department"
      @deptSelected="setDeptToMove"
    ></select-department-dialog>

    <individual-selection-dialog
      v-if="select_individual_dialog"
      :association="associations[this.current_association]"
      :department="department"
      @selected="handleSelectedIndividual"
    ></individual-selection-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "MoveAssociations",
  components: {
    SelectDepartmentDialog: () => import("../../shared/SelectDepartmentDialog.vue"),
    IndividualSelectionDialog: () => import('../associations/IndividualSelectionDialog.vue')
  },
  props: {
    department: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      loading: false,
      loading_text: null,
      associations: null,
      submiting_move: false,
      local_dept: null,
      saving: false,
      associations_map: {
        "forms": {
          text: "Formulários",
          icon: ''
        },
        "flows": {
          text: "Fluxos",
          icon: ''
        },
        "action_plans": {
          text: "Planos de ação",
          icon: ''
        },
        "employees": {
          text: "Colaboradores",
          icon: ''
        },
        "children": {
          text: "Departamentos filhos",
          icon: ''
        }
      },
      select_dept_dialog: false,
      select_individual_dialog: false
    }
  },
  mounted () {
    this.getAssociations();
  },
  methods: {
    handleSelectedIndividual(association) {
      this.associations[this.current_association] = {...association};
      this.select_individual_dialog = false;
    },
    setDeptToMove(dept) {
      this.associations[this.current_association].dept_id = dept.id;
      this.select_dept_dialog = false;
    },
    setMoveType(association, type) {
      this.associations[association.name].type = type;
      this.current_association = association.name;
      if (type == 'all') {
        this.select_dept_dialog = true;
      } else if (type == 'individual') {
        this.select_individual_dialog = true;
      }
    },
    async getAssociations() {
      this.loading = true;
      this.loading_text = "Carregando";

      this.departmentAssociations({department_id: this.department.id, solution_id: this.solution_id}).then((associations) => {
        // this.associations = [...associations];
        this.associations = associations.reduce((a, v) => ({ 
          ...a,
          [v]: {
            name: v,
            move: false, 
            type: null, // "all" || "individual",
            items: [],
            dept_id: null
          }
        }), {});
        this.loading = false;
        this.loading_text = null;
      });
    },
    submitMove() {
      this.submiting_move = true;
      if (this.can_move) {
        this.saving = true;
        this.loading_text = "Movendo";

        let dept = {
          ...this.department,
          associations: {...this.associations},
          solution_id: this.solution_id
        }
  
        this.moveAssociations(dept).then(() => {
          this.saving = false;
          this.loading_text = null;
          this.$emit("updated");
        })
      }
    },
    ...mapActions({
      departmentAssociations: "Department/departmentAssociations",
      moveAssociations: "Department/moveAssociations"
    })
  },
  computed: {
    can_move() {
      let can_move = true;
      let check_is_moving = []

      for (let association in this.associations) {
        check_is_moving.push(this.associations[association].move);
        if (this.associations[association].move == true) {
          if (this.associations[association].type == "individual") {
            if (!this.associations[association].items.length || !this.associations[association].dept_id) {
              can_move = false;
            }
          } else if (this.associations[association].type == "all") {
            if (!this.associations[association].dept_id) {
              can_move = false;
            }
          }
        }
      }

      if (!check_is_moving.includes(true)) {
        can_move = false;
      }

      return can_move;
    },
    ...mapState({
      solution_id: state=>state.Solution.solutionID
    })
  },
  watch: {
    
  }
}
</script>

<style scoped>

</style>